import { useQuery } from '@tanstack/react-query'
import { GlossariesApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { glossaryQueryKeys } from './queryKeys'

export const useQueryGlossaryJobs = () => {
  return useQuery({
    queryKey: glossaryQueryKeys.glossaryJobs.list(),
    queryFn: () => baseClient.getApi(GlossariesApi).getGlossaryJobs(),
    select: data => ({
      glossaryJobs: data.glossaryJobs ?? [],
    }),
    retry: 0,
    staleTime: 0,
  })
}
